import type { BlocksContent } from "@strapi/blocks-react-renderer";
import clsx from "clsx";
import { useCallback, useState } from "react";

import { CommonBlocksRenderer } from "@widgets/common-blocks-renderer";

import type { AccordionsTextType } from "@features/article-content/model/types";

import { Accordion } from "@shared/ui/accordion/accordion";
import { Heading } from "@shared/ui/typography";

import s from "./accordions-text.module.scss";

export const AccordionsText = (props: AccordionsTextType) => {
  const { accordion, title } = props;

  const [activeAccordion, setActiveAccordion] = useState<string | null>(
    accordion?.[0]?.id != null ? `${accordion[0].id}` : null,
  );

  const handleOpenAccordion = useCallback((id: string) => {
    setActiveAccordion((prev) => (prev === id ? null : id));
  }, []);

  return (
    <div className={clsx(s.root)}>
      {title && (
        <Heading level={4} className={s.title}>
          {title}
        </Heading>
      )}
      <div className={s.accordions}>
        {accordion?.length > 0 &&
          accordion.map((item) =>
            item && (item.title != null || item.text != null) ? (
              <Accordion
                key={item?.id ?? item?.title ?? Math.random()}
                title={item?.title ?? ""}
                id={`${item?.id ?? ""}`}
                className={s.accordion}
                isOnceOpen
                activeAccordion={activeAccordion}
                onAccordionClick={handleOpenAccordion}
                titleClassName={s.accordionTitle}
              >
                {item?.text && (
                  <CommonBlocksRenderer
                    data={item.text as unknown as BlocksContent}
                  />
                )}
              </Accordion>
            ) : null,
          )}
      </div>
    </div>
  );
};

AccordionsText.displayName = "AccordionsText";
